/*
 * Calculadora de racion diaria (comida deshidratada).
 * Markup y porcentajes: snippets/calculadora-racion.liquid
 * Vanilla JS a proposito: Easy Bundles sobrescribe $.ajax (ver CLAUDE.md).
 */
(function () {
  "use strict";

  var TAB_CONTENT = "tabContentRacion";
  var CLAVE_STORAGE = "nw-calc-racion";

  var FACTOR_GRAMOS = { mg: 0.001, g: 1, kg: 1000 };
  var UNIDADES_TEXTO = { g: 1, gr: 1, grs: 1, gramo: 1, gramos: 1, kg: 1000, kgs: 1000, kilo: 1000, kilos: 1000 };
  var RE_CANTIDAD = /(?:(\d+)\s*[x×]\s*)?(\d+(?:[.,]\d+)?)\s*(kilos|kilo|kgs|kg|gramos|gramo|grs|gr|g)\b/i;
  var RE_SIN_UNIDAD = /^\s*(?:bolsa|envase|lata|formato)\s+(\d{2,4})\b(?!\s*[.,]?\d)/i;

  function numero(n, decimales) {
    return n.toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: decimales || 0 });
  }

  function euros(centimos) {
    return (centimos / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
  }

  /* Gramos de un formato: primero el "precio por unidad" de Shopify, si no, el nombre. */
  function gramosDeVariante(v) {
    if (v.cantidad && v.unidad) {
      var f = FACTOR_GRAMOS[String(v.unidad).toLowerCase()];
      if (f) return v.cantidad * f;
    }
    var m = RE_CANTIDAD.exec(v.titulo || "");
    if (m) return parseInt(m[1] || "1", 10) * parseFloat(m[2].replace(",", ".")) * UNIDADES_TEXTO[m[3].toLowerCase()];
    m = RE_SIN_UNIDAD.exec(v.titulo || "");
    if (m) return parseFloat(m[1]);
    return null;
  }

  function leerStorage() {
    try { return JSON.parse(window.localStorage.getItem(CLAVE_STORAGE)) || {}; } catch (e) { return {}; }
  }

  function guardarStorage(datos) {
    try { window.localStorage.setItem(CLAVE_STORAGE, JSON.stringify(datos)); } catch (e) { /* sin almacenamiento */ }
  }

  function iniciar(raiz) {
    var q = function (sel) { return raiz.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(raiz.querySelectorAll(sel)); };

    var porcentajes = {};
    qa("tr[data-clave]").forEach(function (tr) {
      porcentajes[tr.getAttribute("data-clave")] = {
        pct: parseFloat(tr.getAttribute("data-pct")),
        texto: tr.getAttribute("data-pct-texto"),
        fila: tr
      };
    });

    var variantes = [];
    try { variantes = JSON.parse(q("[data-calc-variantes]").textContent); } catch (e) { variantes = []; }
    variantes.forEach(function (v) { v.gramos = gramosDeVariante(v); });
    var formatos = variantes.filter(function (v) { return v.gramos; });

    var peso = q("[data-calc-peso]");
    var rango = q("[data-calc-rango]");
    var mostrarCoste = raiz.getAttribute("data-coste-dia") === "true";
    var guardado = leerStorage();

    var estado = {
      especie: raiz.getAttribute("data-especie") || "perro",
      etapa: raiz.getAttribute("data-etapa") || "adulto"
    };

    function marcar(nombre, valor) {
      var el = raiz.querySelector('input[name="' + nombre + '"][value="' + valor + '"]');
      if (el) el.checked = true;
    }

    function valor(nombre) {
      var el = raiz.querySelector('input[name="' + nombre + '"]:checked');
      return el ? el.value : null;
    }

    function aplicarGuardado() {
      var g = guardado[estado.especie];
      if (!g) {
        peso.value = estado.especie === "gato" ? 4 : 10;
        return;
      }
      if (g.peso) peso.value = g.peso;
      if (g.actividad) marcar("cr-actividad", g.actividad);
      if (g.edad) marcar("cr-edad-" + estado.especie, g.edad);
    }

    function visibilidad() {
      rango.max = estado.especie === "gato" ? 12 : 70;
      qa("[data-solo-especie]").forEach(function (el) {
        el.hidden = el.getAttribute("data-solo-especie") !== estado.especie;
      });
      qa("[data-solo-etapa]").forEach(function (el) {
        var ok = el.getAttribute("data-solo-etapa").split(" ").indexOf(estado.etapa) > -1;
        var especieOk = !el.hasAttribute("data-solo-especie") || el.getAttribute("data-solo-especie") === estado.especie;
        el.hidden = !(ok && especieOk);
      });
      var textoCachorro = q("[data-calc-texto-cachorro]");
      if (textoCachorro) textoCachorro.textContent = estado.especie === "gato" ? "Gatito" : "Cachorro";
    }

    function claveActual() {
      if (estado.etapa === "cachorro") return estado.especie + ":cachorro:" + valor("cr-edad-" + estado.especie);
      if (estado.especie === "gato") return "gato:adulto:todos";
      return "perro:" + estado.etapa + ":" + valor("cr-actividad");
    }

    function varianteSeleccionada() {
      var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return form ? parseInt(form.value, 10) : null;
    }

    function pintar() {
      var kg = parseFloat(String(peso.value).replace(",", ".")) || 0;
      var dato = porcentajes[claveActual()];
      if (!dato) return;

      var gramos = kg * dato.pct * 1000;
      q("[data-calc-gramos]").textContent = numero(gramos, gramos < 100 ? 1 : 0);
      q("[data-calc-detalle]").textContent = kg > 0
        ? "El " + dato.texto + " % de sus " + numero(kg, 1) + " kg de peso."
        : "Indica su peso para calcular la ración.";

      qa("tr[data-clave]").forEach(function (tr) { tr.classList.remove("is-activa"); });
      dato.fila.classList.add("is-activa");

      var bloque = q("[data-calc-formatos]");
      var filas = q("[data-calc-formatos-filas]");
      bloque.hidden = !(formatos.length && gramos > 0);
      q("[data-calc-col-coste]").hidden = !mostrarCoste;
      filas.textContent = "";
      if (!bloque.hidden) {
        var elegida = varianteSeleccionada();
        formatos.forEach(function (v) {
          var dias = v.gramos / gramos;
          var tr = document.createElement("tr");
          if (v.id === elegida) tr.className = "is-activa";

          var th = document.createElement("th");
          th.scope = "row";
          th.textContent = v.titulo;
          tr.appendChild(th);

          var tdDias = document.createElement("td");
          tdDias.className = "calc-racion__num";
          tdDias.textContent = dias >= 1 ? numero(Math.floor(dias)) : "menos de 1";
          tr.appendChild(tdDias);

          if (mostrarCoste) {
            var tdCoste = document.createElement("td");
            tdCoste.className = "calc-racion__num";
            tdCoste.textContent = euros(v.precio / dias);
            tr.appendChild(tdCoste);
          }
          filas.appendChild(tr);
        });
      }

      guardado[estado.especie] = {
        peso: peso.value,
        actividad: valor("cr-actividad"),
        edad: valor("cr-edad-" + estado.especie)
      };
      guardarStorage(guardado);
    }

    marcar("cr-especie", estado.especie);
    marcar("cr-etapa", estado.etapa);
    aplicarGuardado();
    rango.value = peso.value;
    visibilidad();
    pintar();

    raiz.addEventListener("input", function (e) {
      if (e.target === rango) peso.value = rango.value;
      if (e.target === peso) {
        var v = parseFloat(String(peso.value).replace(",", "."));
        if (!isNaN(v)) rango.value = v;
      }
      if (e.target === rango || e.target === peso) pintar();
    });

    raiz.addEventListener("change", function (e) {
      if (e.target.name === "cr-especie") {
        estado.especie = e.target.value;
        if (estado.especie === "gato" && estado.etapa === "senior") {
          estado.etapa = "adulto";
          marcar("cr-etapa", "adulto");
        }
        aplicarGuardado();
        rango.value = peso.value;
      }
      if (e.target.name === "cr-etapa") estado.etapa = e.target.value;
      visibilidad();
      pintar();
    });

    // Al cambiar de formato en el selector de la ficha, resaltar su fila
    document.addEventListener("change", function (e) {
      if (!raiz.contains(e.target)) window.setTimeout(pintar, 50);
    });
  }

  function abrirCalculadora(e) {
    var raiz = document.querySelector("[data-calculadora-racion]");
    if (!raiz) return;
    if (e) e.preventDefault();
    var pestana = document.querySelector('.yv-tab-product-item[content="' + TAB_CONTENT + '"]');
    if (pestana && !pestana.classList.contains("active")) pestana.click();
    var reducido = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    raiz.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
    var peso = raiz.querySelector("[data-calc-peso]");
    if (peso) peso.focus({ preventScroll: true });
  }

  function arrancar() {
    var raiz = document.querySelector("[data-calculadora-racion]");
    if (raiz) iniciar(raiz);

    document.addEventListener("click", function (e) {
      var enlace = e.target.closest && e.target.closest("[data-abrir-calculadora]");
      if (enlace) abrirCalculadora(e);
    });

    if (window.location.hash === "#calculadora-racion") {
      window.setTimeout(function () { abrirCalculadora(); }, 300);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }
})();
